import type { Robot } from '$lib/patterns/strategy/examples/types';
type Message = Robot.Message;
import type { Caching } from './shared/strategy/Cached_API'
import type { Get_Content } from './shared/strategy/Content';

import { Dad_Joke, Stoicism_Quote, Comedian_Joke } from './shared/strategy/Content';
import { Cached_Message, Uncached_Message } from './shared/strategy/Cached_API';







class Chatbot {
	constructor(
		public name: string,
		public avatar: string,
		protected behavior: Get_Content,
		protected cache: Caching
	) { }

	async getMessage(): Promise<Message> {
		return {
			author: this.name,
			avatar: this.avatar,
			content: await this.cache.getValue(this.behavior.getContent),
			log: this.cache.getStatusUpdate(),
			time: new Date().toLocaleTimeString(),
		}
	}

	
}

export default {
	Chatbot: {
		class: Chatbot,
	},
	Stoicism_Bot: {
		class: Stoicism_Quote,
		init: () => new Chatbot(
			'Stoicism Bot',
			'stoicism-bot',
			new Stoicism_Quote(),
			new Cached_Message('Stoicism Bot')
		),
	},
	Dad_Joke_Bot: {
		class: Dad_Joke,
		init: () => new Chatbot(
			'Dad Joke Bot',
			'dad-bot',
			new Dad_Joke(),
			new Cached_Message('Dad Joke Bot')
		),
	},
	Comedian_Bot: {
		class: Comedian_Joke,
		init: () => new Chatbot(
			'Comedian Bot',
			'comedian-bot',
			new Comedian_Joke(),
			new Uncached_Message('Comedian Bot')
		),
	},
}